<template>
  <div class="bto-sb-event-mormarket-market-odd bto-sb-mormarket-odd">
    <span class="bto-sb-mormarket-cell" v-for="(team, idx) in ['home', 'guest']" :key="idx">
      <span class="bto-sb-event-mormarket-market-slider-name bto-sb-mormarket-market-slider-name">
        {{match[`${team}Team`]}}
      </span>
      <div class="bto-sb-filter-slider-content">
        <range-slider-component
          :values="calculateValues(team)"
          :handlerFunction="(value) => sliderHandler(value, team)"
        />
      </div>
    </span>

    <span class="bto-sb-event-mormarket-market-slider-results bto-sb-mormarket-cell bto-sb-mormarket-slider-results">
      <component
        :is="match.isLiveMatch ? 'match-odd-live-details-component' : 'match-odd-component'"
        :match="match"
        :odd="getCurrentOdd()"
        :outcome="getSliderOutcome()"
        :isDetails="true"
        :isPrematch="!match.isLiveMatch"
        :lockEmptyOdd="false"
      />
    </span>
  </div>
</template>

<script>
  import RangeSliderComponent from '../../../common/range-slider-component';
  import MatchOddComponent from '../../../common/match/match-odd-component';
  import MatchOddLiveDetailsComponent from '../../../common/match/match-odd-live-details-component';

  export default {
    name: 'OddRowSlidersComponent',
    data() {
      return {
        currentSliderCombination: {
          home: undefined,
          guest: undefined,
          delimiter: '',
        },
        outcomes: {
          home: {},
          guest: {},
          delimiter: '',
        },
      };
    },
    props: {
      match: {
        type: Object,
        required: true,
        default: () => { },
      },
      tabIdx: {
        type: Number,
        required: true,
        default: null,
      },
      oddIdx: {
        type: Number,
        required: true,
        default: null,
      },
    },
    created() {
      let outcomes = {
        home: {},
        guest: {},
      };
      this.match
        .tabs[this.tabIdx].odds[this.oddIdx]
        .outcomes.filter(outcome => /\d*\.?\d*(:|-)\d+\.*\d*$/.test(outcome.name))
        .map(outcome => {
          let values = [];
          let delimiter = ':';
          if (outcome.name.indexOf(':') > -1) {
            delimiter = ':';
            values = outcome.name.split(':');
          } else {
            delimiter = '-';
            values = outcome.name.split('-');
          }
          outcomes.home[values[0]] = true;
          outcomes.guest[values[1]] = true;
          outcomes.delimiter = delimiter;
        });

      this.outcomes = outcomes;

      let currentSliderCombination = {
        home: undefined,
        guest: undefined,
      };

      currentSliderCombination.home = Object.keys(outcomes.home)[0];
      currentSliderCombination.guest = Object.keys(outcomes.guest)[0];
      currentSliderCombination.delimiter = outcomes.delimiter;

      this.currentSliderCombination = currentSliderCombination;
    },
    methods: {
      sliderHandler(value, team) {
        this.currentSliderCombination[team] = value;
      },
      getCurrentOdd() {
        return this.match.tabs[this.tabIdx].odds[this.oddIdx];
      },
      getSliderOutcome() {
        let emptyOutcome = {
          id: 'N/A',
          name: this.t('W.NA'),
          originalDecimalOutcome: '--'
        };

        let otherOutcome = this.match
          .tabs[this.tabIdx].odds[this.oddIdx]
          .outcomes.find(outcome => outcome.name.indexOf(this.currentSliderCombination.delimiter) === -1);

        return this.match
          .tabs[this.tabIdx].odds[this.oddIdx]
          .outcomes.find(outcome =>
            outcome.name === `${this.currentSliderCombination.home}${this.currentSliderCombination.delimiter}${this.currentSliderCombination.guest}`
          ) || otherOutcome || emptyOutcome; // eslint-disable-line
      },
      calculateValues(team) {
        return Object.keys(this.outcomes[team]);
      },
    },
    components: {
      RangeSliderComponent,
      MatchOddComponent,
      MatchOddLiveDetailsComponent,
    },
  };
</script>
